import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import exportIcon from '@adsk/bim360-matrix-react-assets/export.svg';

import './_LinkButton.scss';

export default function LinkButton({ link, label, className }) {
  function onClick(e) {
    e.preventDefault();
    window.open(link);
    return false;
  }

  return (
    <Button styleType={Button.StyleType.INLINE_LINK} onClick={onClick} className={className}>
      <span className="LinkButton__text">{label}</span>
      <SvgIcon>{exportIcon}</SvgIcon>
    </Button>
  );
}

LinkButton.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  className: PropTypes.string
};
